<template lang="pug">
div.my-4
  template(v-for="service in getServices")
    .d-flex.align-center.my-4(:class="{ 'clickable': !readonly }" @click="onClickSelection(service)")
      yc-checkbox.mr-2(v-if="!readonly" v-model="selectedServices" :value="service" :disabled="isDisabledToSelect")
      .text-xs.neutral700--text {{ service.name }}
  .d-flex.justify-end.mt-4
    v-btn.button-sm.mr-3(v-if="!readonly" color="primary" :disabled="!canAddToCurrent" outlined :loading="isLoadingAddToCurrent" @click="onAddToCurrent") {{ $t('add_to_current') }}
    v-btn.button-sm(color="primary" :disabled="isDisabledToViewDetails" depressed @click="$emit('viewDetails')") {{ $t('view_details') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
    parentRegistration: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedServices: [],
      isLoadingAddToCurrent: false
    }
  },
  computed: {
    leadPid() {
      return this.$route.params.pid
    },
    getServices() {
      return this.parentHistory?.services ?? []
    },
    isDisabledToSelect() {
      return this.parentRegistration.status !== 'serving'
    },
    isDisabledToViewDetails() {
      return this.getServices.length === 0
    },
    canAddToCurrent() {
      if (this.isDisabledToViewDetails) {
        return false
      }
      return this.selectedServices.length > 0
    },
    payload() {
      return this.selectedServices.map(service => this.filterPayloadObject(service))
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    onClickSelection(value) {
      if (this.readonly) return
      if (this.isDisabledToSelect) {
        this.showMessage(['error', this.$t('error_message.call_patient_in_first')])
        return
      }
      if (this.selectedServices.includes(value)) {
        this.selectedServices = this.selectedServices.filter(x => x !== value)
      } else {
        this.selectedServices.push(value)
      }
    },
    filterPayloadObject(obj) {
      const allowedProperties = ['product', 'quantity', 'price', 'extra_data']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      filteredObj.product = filteredObj.product.id
      return filteredObj
    },
    async onAddToCurrent() {
      this.isLoadingAddToCurrent = true
      try {
        await this.$axios.patch(`/leads/${this.leadPid}`, { products: this.payload })
        this.$emit('updated')
        this.selectedServices = []
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoadingAddToCurrent = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>